// ─────────────────────────────────────────────
//  StockAnalysis.js — Full 5-tab Stock Analysis
//  Phase 3: Fundamental | Technical | Financials | News
//  Phase 4: AI Signals (live — Claude API)
// ─────────────────────────────────────────────
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import StockHeader    from "../components/stock/StockHeader";
import FundamentalTab from "../components/stock/FundamentalTab";
import TechnicalTab   from "../components/stock/TechnicalTab";
import FinancialsTab  from "../components/stock/FinancialsTab";
import NewsTab        from "../components/stock/NewsTab";
import AISignalsTab   from "../components/stock/AISignalsTab";
import "./StockAnalysis.css";

// icon  — emoji shown large on mobile
// label — short ALL-CAPS text shown below icon on mobile; full label on desktop
// desc  — subtitle shown only on wide screens
const TABS = [
  { key: "fundamental", icon: "📋", label: "Fundamental", shortLabel: "Funds",    desc: "Valuation & company overview"  },
  { key: "technical",   icon: "📈", label: "Technical",   shortLabel: "Chart",    desc: "Charts, RSI, MACD, S&R"        },
  { key: "financials",  icon: "💰", label: "Financials",  shortLabel: "P&L",      desc: "P&L, Balance Sheet, Cash Flow" },
  { key: "news",        icon: "📰", label: "News",        shortLabel: "News",     desc: "Management & news feed"        },
  { key: "ai",          icon: "🤖", label: "AI Signals",  shortLabel: "AI",       desc: "Entry, Exit, Stop Loss"        },
];

export default function StockAnalysis() {
  const { symbol }               = useParams();
  const navigate                 = useNavigate();
  const [exchange, setExchange]  = useState("NSE");
  const [activeTab, setActiveTab]= useState("fundamental");

  const sym = symbol?.toUpperCase() || "";

  return (
    <div className="sa-page">
      {/* ── Back navigation ── */}
      <button className="sa-back" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* ── Live price header ── */}
      <StockHeader
        symbol={sym}
        exchange={exchange}
        onExchangeChange={setExchange}
      />

      {/* ── Tab bar ── */}
      <div className="sa-tab-bar" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`sa-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {/* Icon: shown large + standalone on mobile via CSS */}
            <span className="sa-tab-icon" aria-hidden="true">{tab.icon}</span>

            {/* Label: on desktop shows "📋 Fundamental", on mobile shows "FUNDS" */}
            <span className="sa-tab-label sa-tab-label--desktop">
              {tab.icon} {tab.label}
            </span>
            <span className="sa-tab-label sa-tab-label--mobile">
              {tab.shortLabel}
            </span>

            {/* Subtitle shown only on wide screens */}
            <span className="sa-tab-desc">{tab.desc}</span>
          </button>
        ))}
      </div>

      {/* ── Tab content ── */}
      <div className="sa-tab-content" role="tabpanel">
        {activeTab === "fundamental" && <FundamentalTab symbol={sym} exchange={exchange} />}
        {activeTab === "technical"   && <TechnicalTab   symbol={sym} exchange={exchange} />}
        {activeTab === "financials"  && <FinancialsTab  symbol={sym} exchange={exchange} />}
        {activeTab === "news"        && <NewsTab        symbol={sym} exchange={exchange} />}
        {activeTab === "ai"          && <AISignalsTab   symbol={sym} exchange={exchange} />}
      </div>
    </div>
  );
}